import "./compat/runtime";
import { installDomCompatibility } from "./compat/dom";

installDomCompatibility();
void import("./bootstrap").catch(error => {
  const root = document.getElementById("root");
  if (root) { root.setAttribute("role", "alert"); root.textContent = `工作台载入失败：${error instanceof Error ? error.message : "请刷新页面重试"}`; }
});
